import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { OccupancyState, ResourceOccupancyStateParameters, useRepositoryQuery } from '@mews-commander/data-access';

export const useResourceOccupancyStateQuery = (params: ResourceOccupancyStateParameters) =>
    useRepositoryQuery('resources', 'getOccupancyState', params, {
        select: (resp) => ({
            ...resp,
            aggregatedData: {
                occupancyStatesByResourceId: pipe(
                    resp.resourceCategoryOccupancyStates || [],
                    array.flatMap((state) => state.resourceOccupancyStates ?? []),
                    array.reduce({} as Record<string, OccupancyState[]>, (acc, resourceOccupancyState) => {
                        acc[resourceOccupancyState.resourceId] = acc[resourceOccupancyState.resourceId] ?? [];
                        acc[resourceOccupancyState.resourceId].push(resourceOccupancyState.occupancyState);
                        return acc;
                    })
                ),
            },
        }),
    });
